export default {
      id: "tag_not-registered-usage",
      viewBox: "0 0 31 30",
      url: __webpack_public_path__ + "img/icons.svg#tag_not-registered",
      toString: function () {
        return this.url;
      }
    }